import { render, staticRenderFns } from "./reset-default.vue?vue&type=template&id=2d1bbe4a&"
import script from "./reset-default.vue?vue&type=script&lang=js&"
export * from "./reset-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1bbe4a')) {
      api.createRecord('2d1bbe4a', component.options)
    } else {
      api.reload('2d1bbe4a', component.options)
    }
    module.hot.accept("./reset-default.vue?vue&type=template&id=2d1bbe4a&", function () {
      api.rerender('2d1bbe4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/reset-default.vue"
export default component.exports